import { Box, Button } from '@mui/material'
import { GridRowId } from '@mui/x-data-grid'
import { isEqual, uniqWith } from 'lodash-es'
import { IGetFields } from 'screens/Shipments/helpers/getFields'

interface IGridToolbarCopyFieldsProps {
  selectedRows: Map<GridRowId, any>
  buildRow: IGetFields
  uniqueRows?: boolean
  title: string
}

const GridToolbarCopyFields = (props: IGridToolbarCopyFieldsProps) => {
  const { selectedRows, buildRow, title, uniqueRows = false } = props

  const onClick = () => {
    const rows = Array.from(selectedRows.values()).map((row) => buildRow(row))
    const resultRows = uniqueRows ? uniqWith(rows, isEqual) : rows
    const clipboardData = resultRows.map((row) => row.join('	')).join('\n')
    navigator.clipboard.writeText(clipboardData)

    const csvData = resultRows.map((row) => row.join(',')).join('\n')
    const blob = new Blob([csvData], { type: 'text/csv' })
    const url = URL.createObjectURL(blob)
    const a = document.createElement('a')
    a.href = url
    const date = new Date().toISOString().split('T')[0]
    const titleFormatted = window.location.href.split('/').pop()?.replace(/\s+/g, '-').toLowerCase()
    a.download = `${titleFormatted}-${date}.csv`
    document.body.appendChild(a)
    a.click()
    document.body.removeChild(a)
  }

  return (
    <Box mx={1}>
      <Button size="small" variant="contained" onClick={onClick}>
        {title}
      </Button>
    </Box>
  )
}

export default GridToolbarCopyFields
